// static/js/components/ui/ToolsToggleButton.jsx

import React from 'react';
import { Wrench } from 'lucide-react';

const ToolsToggleButton = ({ toolMode, onToggle }) => {
  // Get display text and style based on current mode
  const getDisplayInfo = () => {
    switch (toolMode) {
      case 'always':
        return { text: 'Tools: Always', bgColor: 'bg-primary-button text-black' };
      case 'never':
        return { text: 'Tools: Never', bgColor: 'bg-red-500/20 text-primary-text' };
      default: // 'auto'
        return { text: 'Tools: Auto', bgColor: 'bg-primary-700/10 text-primary-text' };
    }
  };

  const { text, bgColor } = getDisplayInfo();

  return (
    <button
      onClick={onToggle}
      className={`flex items-center gap-2 px-4 py-2 rounded-full 
        transition-colors hover:bg-primary-700/20 ${bgColor}`}
      title="Control whether AI tools are used when responding"
    >
      <Wrench size={16} />
      <span className="text-sm">{text}</span>
    </button>
  );
};

export default ToolsToggleButton;